import { lazy } from 'react';
import { OnboardingTemplate } from '../data/steps-content';

export const ONBOARDING_TEMPLATE_REGISTRY = {
  CompletionRfp: lazy(() => import('../components/templates/CompletionRfp')),
  Form: lazy(() => import('../components/templates/Form')),
  Notifications: lazy(() => import('../components/templates/Notifications')),
  Payment: lazy(() => import('../components/templates/Payment')),
  RfpProject: lazy(() => import('../components/templates/RfpProject')),
  ValidationGrants: lazy(
    () => import('../components/templates/ValidationGrants'),
  ),
  Welcome: lazy(() => import('../components/templates/Welcome')),
} satisfies Record<OnboardingTemplate, React.LazyExoticComponent<React.FC>>;
